import React from 'react';
import { Button, Modal } from 'ui-component-library';
import { bool, func } from 'prop-types';

import LabelValue from '../../card-shared-components/card-label-value/card-label-value';
import { Value } from '../../card-shared-components/card-label-value/card-label-value.style';
import { BindingsContainer, CloseButtonContainer } from './hot-key-info-modal.style';

/**
 * The hot key info modal
 * @param {object} params - Object containing props
 * @param {boolean} params.open - Boolean to specify if modal is open
 * @param {function} params.onClose - Function to handle closing the modal
 * @return {element}
 */
const HotKeyInfoModal = ({ open, onClose }) => {
  const title = 'Keyboard Shortcuts';
  const isMac = navigator.platform.toUpperCase().includes('MAC');
  return (
    <div data-testid="hot-key-info-modal">
      <Modal
        title={title}
        isOpen={open}
        onModalClose={onClose}
        width="500px"
      >
        <Value>Take advantage of keyboard shortcuts to navigate the Tracking Queue more efficiently:</Value>
        <BindingsContainer>
          <LabelValue label="Arrow Up/Down" value="Navigate between rows" options={{ gridColumnTemplate: '0.75fr 1.25fr' }} />
          <LabelValue label="Enter" value="Open the selected row's detail view" options={{ gridColumnTemplate: '0.75fr 1.25fr' }} />
          <LabelValue label={isMac ? 'Fn + Arrow Up' : 'Page Up'} value="Skip up the queue" options={{ gridColumnTemplate: '0.75fr 1.25fr' }} />
          <LabelValue label={isMac ? 'Fn + Arrow Down' : 'Page Down'} value="Skip down the queue" options={{ gridColumnTemplate: '0.75fr 1.25fr' }} />
          <LabelValue label={isMac ? 'Fn + Arrow Left' : 'Home'} value="Jump to the top of the queue" options={{ gridColumnTemplate: '0.75fr 1.25fr' }} />
          <LabelValue label={isMac ? 'Fn + Arrow Right' : 'End'} value="Jump to the bottom of the loaded rows" options={{ gridColumnTemplate: '0.75fr 1.25fr' }} />
        </BindingsContainer>
        <CloseButtonContainer>
          <Button text="Close" onClick={onClose} />
        </CloseButtonContainer>
      </Modal>
    </div>
  );
};

HotKeyInfoModal.propTypes = {
  open: bool.isRequired,
  onClose: func,
};

HotKeyInfoModal.defaultProps = {
  onClose: () => { },
};

export default HotKeyInfoModal;
